import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {Table,TableCell,TableContainer,TableHead,TableRow,TableBody,FormControlLabel,Checkbox,Autocomplete,Box,Tab,Tabs,Button,Typography,Grid,TextField,InputLabel,Select,OutlinedInput,MenuItem,FormControl,Card,CardContent,CardHeader,CircularProgress,Paper} from '@mui/material';
import PropTypes from 'prop-types';
import unsplash from "../api/unsplash";
import { DatePicker ,LocalizationProvider} from "@mui/lab";
import DateAdapter from '@mui/lab/AdapterMoment';
import moment from "moment";
import momentTimezone from "moment-timezone";
import ReactHTMLTableToExcel from "react-html-table-to-excel"

const Allegati3B = () => {
    const [value, setValue] = useState(0);
    const [clienti,setClienti] = useState([]);
    const [clienteSel,setClienteSel] = useState(0);
    const [sedi,setSedi] = useState([]);
    const [sedeSel,setSedeSel] = useState("");
    const [dal,setDal] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [al,setAl] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [cessati,setCessati] = useState(true);
    const [risultato,setRisultato] = useState([]);


const handleChangeTab = (event, newValue) => {
        setCessati(true);
        setValue(newValue);
        setClienteSel(0);
        if(newValue === 0){
        setDal(new Date());
        setAl(new Date());
        }else{
          setDal(null);
          setAl(null);
        }
        setSedeSel("");  
        setRisultato([]);
      }

const handleChangeCliente = async (cliente) =>{
 setSedeSel("");
 if(cliente){
  setClienteSel(cliente.id);

let response = await  unsplash.get('sedi', {params:{id:cliente.id},headers: {
  'Authorization': `Bearer ${localStorage.getItem('jwt')}`}
});
let unitaProd = [];
for(let i=0;i<response.data.data.length;i++){
let sede = response.data.data[i].UnitaProduttiva; 

if(unitaProd.indexOf(response.data.data[i].UnitaProduttiva) === -1 && response.data.data[i].UnitaProduttiva!="" && response.data.data[i].UnitaProduttiva){
  unitaProd.push(response.data.data[i].UnitaProduttiva);
}


}
setSedi(unitaProd);
 }else{
  setSedi([]);
 }
} 

const handleLoad = async() => {
  let response = await  unsplash.get('allegato3B', {params:{tipo:value,cliente:clienteSel,unita:sedeSel,dal:dal,al:al,cessati:cessati},headers: {
    'Authorization': `Bearer ${localStorage.getItem('jwt')}`}
});
setRisultato(response.data.res);
}



useEffect(() => {// è un loop qui carico i dati 
        const fetchData = async () =>{
    
          try {
        
                      let response = await  unsplash.get('clienti', {headers: {
                        'Authorization': `Bearer ${localStorage.getItem('jwt')}`}
                    });
                    let inserd =[];
                    let cli = [];
                    for(let i=0;i<response.data.data.length;i++){ //per evitare doppioni

                    if(inserd.indexOf(response.data.data[i].RagioneSociale) === -1){
                      
                      cli.push({label:response.data.data[i].RagioneSociale,id:response.data.data[i].ID})
                      inserd.push(response.data.data[i].RagioneSociale);
                    }

                    }
      
                    setClienti(cli)
              
                                    
          } catch (error) {
            console.error(error.message);
          }
          
        }
    
        fetchData();
       
      }, []);
    



return(<>
    <Grid item xs={12}>
 
      <Card sx={{marginTop:"10px"}}>
      <CardContent>
       <Box>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
         
              <Tabs value={value} textColor="inherit" variant="scrollable" onChange={handleChangeTab} aria-label="basic tabs example">
                <Tab label="Idoneità" {...a11yProps(0)} />
                <Tab  label="Rischi" {...a11yProps(1)} />
                <Tab  label="Accertamenti" {...a11yProps(2)} />
             
              </Tabs>
              </Box>
            <TabPanel value={value} index={0}>{/*Idoneità*/}
            <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={clienti}
               fullWidth
               onChange={(event, newValue) => {
                handleChangeCliente(newValue);
              }}
               renderInput={(params) => <TextField {...params} label="Cliente" />}
              />
              </Grid>
              <Grid item xs={12} md={5}>
              <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={sedi}
               fullWidth
               value={sedeSel}
               onChange={(event, newValue) => {
               
                setSedeSel(newValue?newValue:"");
              }}
               renderInput={(params) => <TextField {...params} label="Unità Prod." />}
              />
              </Grid>
              <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
  
                  ampmInClock={false}
                   renderInput={(props) => <TextField {...props}/>}
                   label="Dal"
                   value={dal}
                   onChange={(newValue) => {
                    setDal(newValue?newValue.format("YYYY-MM-DD"):null);
                }}
                  />
                </LocalizationProvider>

              </Grid>
              <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
  
                  ampmInClock={false}
                   renderInput={(props) => <TextField {...props}/>}
                   label="Al"
                   value={al}
                   onChange={(newValue) => {
                    setAl(newValue?newValue.format("YYYY-MM-DD"):null);
                }}
                  />
                </LocalizationProvider>

              </Grid>
              <Grid item xs={12} md={3}>

              <FormControlLabel control={<Checkbox checked={cessati}  onChange={() => setCessati(!cessati)}/>} label="Considera Cessati" />
              </Grid>
              <Grid item xs={12} md={3}>

              <Button variant="contained" onClick={handleLoad}>Carica</Button>
              <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className={risultato.length>0?"download-table-xls-button":"download-table-xls-button-hide"}
                    table="tabellaIdoneita"
                    filename={"Idoneita"}
                    sheet={"Idoneita"}
                  
                    buttonText="Esporta "/>
              </Grid>
              <Grid item xs={12}>
              <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table" id="tabellaIdoneita">
                <TableHead sx={{backgroundColor:"#2264ae"}}>
                  <TableRow>
                    <TableCell sx={{color:"white"}}>Descrizione</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Maschi</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Femmine</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Totale</TableCell>
                  
                  </TableRow>
                </TableHead>
                <TableBody>
                      {value===0?risultato.map((row) => (
                        <TableRow
                          key={row.Descrizione}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {row.Descrizione}
                          </TableCell>
                          <TableCell align="right">{row.Maschi}</TableCell>
                          <TableCell align="right">{row.Femmine}</TableCell>
                          <TableCell align="right">{row.Tot}</TableCell>
                          
                        </TableRow>
                      )):""}
                    </TableBody>
                  </Table>
                  </TableContainer>
                      </Grid>

               
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>{/*Rischi*/}
            <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={clienti}
               fullWidth
               onChange={(event, newValue) => {
          
                handleChangeCliente(newValue);
              }}
               renderInput={(params) => <TextField {...params} label="Cliente" />}
              />
              </Grid>
              <Grid item xs={12} md={5}>
              <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={sedi}
               fullWidth
               value={sedeSel}
               onChange={(event, newValue) => {
            
                setSedeSel(newValue?newValue:"");
              }}
               renderInput={(params) => <TextField {...params} label="Unità Prod." />}
              />
              </Grid>
              <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
  
                  ampmInClock={false}
                   renderInput={(props) => <TextField {...props}/>}
                   label="Dal"
                   value={dal}
                   onChange={(newValue) => {
                    setDal(newValue?newValue.format("YYYY-MM-DD"):null);
                }}
                  />
                </LocalizationProvider>

              </Grid>
              <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
  
                  ampmInClock={false}
                   renderInput={(props) => <TextField {...props}/>}
                   label="Al"
                   value={al}
                   onChange={(newValue) => {
                    setAl(newValue?newValue.format("YYYY-MM-DD"):null);
                    
                }}
                  />
                </LocalizationProvider>

              </Grid>
              <Grid item xs={12} md={3}>

              <FormControlLabel control={<Checkbox checked={cessati}  onChange={() => setCessati(!cessati)}/>} label="Considera Cessati" />
              </Grid>
              <Grid item xs={12} md={3}>

              <Button variant="contained" onClick={handleLoad}>Carica</Button>
              <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className={risultato.length>0?"download-table-xls-button":"download-table-xls-button-hide"}
                    table="tabellaRischi"
                    filename={"Rischi"}
                    sheet={"Rischi"}
                  
                    buttonText="Esporta "/>
              </Grid>
              <Grid item xs={12}>
              <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table" id="tabellaRischi">
                <TableHead sx={{backgroundColor:"#2264ae"}}>
                  <TableRow>
                    <TableCell sx={{color:"white"}}>Descrizione</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Maschi Tot.</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Femmine Tot.</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Maschi Visitati</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Femmine Visitate</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                      {value===1?risultato.map((row) => (
                        <TableRow
                          key={row.Descrizione}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {row.Descrizione}
                          </TableCell>
                          <TableCell align="right">{row.Maschi}</TableCell>
                          <TableCell align="right">{row.Femmine}</TableCell>
                          <TableCell align="right">{row.NMaschiVisitati}</TableCell>
                          <TableCell align="right">{row.NFemmineVisitate}</TableCell>
                        </TableRow>
                      )):""}
                    </TableBody>
                  </Table>
                  </TableContainer>
                      </Grid>

               
              </Grid>
            </TabPanel>
            <TabPanel value={value} index={2}>{/*Accertamenti*/}
            <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={clienti}
               fullWidth
               onChange={(event, newValue) => {
                handleChangeCliente(newValue);
              }}
               renderInput={(params) => <TextField {...params} label="Cliente" />}
              />
              </Grid>
              <Grid item xs={12} md={5}>
              <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={sedi}
               fullWidth
               value={sedeSel}
               onChange={(event, newValue) => {
         
                setSedeSel(newValue?newValue:"");
              }}
               renderInput={(params) => <TextField {...params} label="Unità Prod." />}
              />
              </Grid>
              <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
  
                  ampmInClock={false}
                   renderInput={(props) => <TextField {...props}/>}
                   label="Dal"
                   value={dal}
                   onChange={(newValue) => {
                    setDal(newValue?newValue.format("YYYY-MM-DD"):null);
                }}
                  />
                </LocalizationProvider>

              </Grid>
              <Grid item xs={12} md={3}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                  <DatePicker
  
                  ampmInClock={false}
                   renderInput={(props) => <TextField {...props}/>}
                   label="Al"
                   value={al}
                   onChange={(newValue) => {
                    setAl(newValue?newValue.format("YYYY-MM-DD"):null);
                }}
                  />
                </LocalizationProvider>

              </Grid>
              <Grid item xs={12} md={3}>

              <FormControlLabel control={<Checkbox checked={cessati}  onChange={() => setCessati(!cessati)}/>} label="Considera Cessati" />
              </Grid>
              <Grid item xs={12} md={3}>

              <Button variant="contained" onClick={handleLoad}>Carica</Button>
              <ReactHTMLTableToExcel
                    id="test-table-xls-button"
                    className={risultato.length>0?"download-table-xls-button":"download-table-xls-button-hide"}
                    table="tabellaAccertamenti"
                    filename={"Accertamenti"}
                    sheet={"Accertamenti"}
                  
                    buttonText="Esporta "/>
              </Grid>
              <Grid item xs={12}>
              <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table" id="tabellaAccertamenti">
                <TableHead sx={{backgroundColor:"#2264ae"}}>
                  <TableRow>
                    <TableCell sx={{color:"white"}}>Descrizione</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Maschi</TableCell>
                    <TableCell align="right" sx={{color:"white"}}>Femmine</TableCell>
               
                  
                  </TableRow>
                </TableHead>
                <TableBody>
                      {value===2?risultato.map((row) => (
                        <TableRow
                          key={row.Accertamento}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            {row.Accertamento}
                          </TableCell>
                          <TableCell align="right">{row.NMaschi}</TableCell>
                          <TableCell align="right">{row.NFemmine}</TableCell>
                          
                        </TableRow>
                      )):""}
                    </TableBody>
                  </Table>
                  </TableContainer>
                      </Grid>

               
              </Grid>
            </TabPanel>
          </Box>
          </CardContent>
          </Card>
          </Grid>
          </>
    )

}



function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  




export default Allegati3B;